import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchMyFavoritesStart = () => {
  return {
    type: actionTypes.FETCH_MY_FAVORITES_START,
  };
};
export const fetchMyFavoritesSuccess = (myFavorites) => {
  return {
    type: actionTypes.FETCH_MY_FAVORITES_SUCCESS,
    myFavorites: myFavorites,
  };
};
export const fetchMyFavoritesFailed = (error) => {
  return {
    type: actionTypes.FETCH_MY_FAVORITES_FAILED,
    payload: error,
  };
};

export const fetchMyFavorites = (userId: string) => {
  return (dispatch) => {
    dispatch(fetchMyFavoritesStart());
    axios
      .get(
        serverconfigs.favoriteProviderUrl+`?userId=${userId}&clientId=${localStorage.getItem(
          "clientId"
        )}&clientGroupId=${localStorage.getItem("clientGroupId")}`
      )
      .then((response) => {
        console.log(serverconfigs.favoriteProviderUrl+`?userId=${userId}`);
        console.log("favorite response is", response.data);
        dispatch(fetchMyFavoritesSuccess(response.data.result));
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchMyFavoritesFailed(error));
      });
  };
};
